module.exports = __webpack_public_path__ + "img/frame-web.b393bece.svg";